module.exports = __webpack_public_path__ + "img/map-close__icon.a26818ad.svg";